<script>
    import EMAIL from './email.svelte';
    import BRAND from './brandConsent.svelte';
    import OPTIONS from './emailConsentOptions.svelte';

    import { createEventDispatcher } from 'svelte';
    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let placeholder = '';
    export let brandLabel = '';
    export let secondBrandTitle = '';
    export let secondBrandMessage = '';
    export let partnerBrandTitle = '';
    export let partnerBrandMessage = '';
    export let partnerBrandAgreementMessage = '';
    export let secondBrandAgreementMessage = '';
    export let error = false;
    export let consentError = false;
    export let brandAgreementMessage = '';

    //METHODS
    const changeEmail = (value) => {
        dispatch('email', value.detail);
    };

    const changeBrandConsent = (value) => {
        dispatch('brandConsent', value.detail);
    };

    const changeSecondBrand = (value) => {
        dispatch('secondBrandConsent', value.detail);
    };

    const changePartnerOptin = (value) => {
        dispatch('partnerOptin', value.detail);
    };
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-justify-content-center">
    <div class="app-msi_form-column">
        <EMAIL {placeholder} on:email={changeEmail} {error} />
        <BRAND label={brandLabel} message={brandAgreementMessage} on:brandConsent={changeBrandConsent} {consentError} />
        <OPTIONS
            {secondBrandTitle}
            {secondBrandMessage}
            {secondBrandAgreementMessage}
            {partnerBrandTitle}
            {partnerBrandMessage}
            {partnerBrandAgreementMessage}
            on:secondBrand={(event) => changeSecondBrand(event)}
            on:partnerOptin={(event) => changePartnerOptin(event)}
        />
    </div>
</div>
